<template>
    <div class="">
        <van-nav-bar left-arrow @click-left="back" style="" title="房抵贷待办列表" fixed/>
        <van-row style="margin: 46px 0 50px 0">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad">
                <van-cell
                        style="padding: 20px"
                        v-for="item in list"
                        is-link
                        @click="toInfo(item.applyId)"
                        center>
                    <template>
                        <div style="display: flex">
                            <div style="width: 10%">
                                <span class="house">房</span>
                            </div>
                            <div style="width: 90%">
                                <div style="display: flex;justify-content: space-between">
                                    <span style="font-weight: bold;">{{item.customerName}}<span style="color: red;margin-left: 5px">{{item.standardFlag ? (item.standardFlag=='yes'? '(标准单)' :'(非标准单)') : ''}}</span></span>
                                    <span>{{item.applyDate | day}}</span>
                                </div>
                                <div>
                                    <span>所属机构：{{item.companyName}}</span>
                                </div>
                                <div>
                                    <span>申请金额：{{item.borrowAmount | formatMoney1}}</span>
                                </div>
                                <div>
                                    <span>申请期限：{{item.borrowTerm}} 月</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </van-cell>
            </van-list>
        </van-row>
    </div>
</template>

<script>

    import {getLoanTodos} from '@/api/loanInfo'
    import {eventBus} from '../../vue/utils/eventBus'
    import {mapGetters} from 'vuex'
    import store from '@/vue/store'
    import Vue from "vue";
    export default {
        name: 'home_index',
        components: {},
        data: function () {
            return {
                pageNo: 1,
                pageSize: 10,
                list: [],
                error: false,
                loading: false,
                finished: false
            }
        },
        computed: mapGetters([
            'userId'
        ]),
        mounted() {

        },
        methods: {
            routerUrl(url) {
                this.$router.push({path: url})
            },
            toInfo(index) {
              console.log(index)
                store.commit('SET_ISMONITORING', false)
                this.$router.push({path: '/mortgage/' + index})
            },
            back() {
                this.$router.go(-1)
            },
            onLoad() {
                let self = this
                //FIXME 获取当前角色
                let data = {
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    productFlag: '1100080',
                    assignUserId: this.userId,
                    processed: 'true'
                }
                getLoanTodos(data).then(res => {
                    this.loading = false
                    //eventBus.$emit('tabbarInfo',res.data.length)
                    if (res.data.length > 0) {
                        this.list = this.list.concat(res.data)
                        if (res.count == this.list.length) {
                            this.finished = true
                        } else {
                            this.pageNo++
                        }
                    } else {
                        this.finished = true
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .grid img {
        width: 28px;
        height: 28px;
    }

    .house {
        padding: 2px;
        border: 1px solid #87d068;
        background: #87d068;
        color: #fff;
        border-radius: 2px;
    }

</style>
